import { render, staticRenderFns } from "./SafetyTrainingHandout.vue?vue&type=template&id=0e54e714"
import script from "./SafetyTrainingHandout.vue?vue&type=script&lang=js"
export * from "./SafetyTrainingHandout.vue?vue&type=script&lang=js"
import style0 from "./SafetyTrainingHandout.vue?vue&type=style&index=0&id=0e54e714&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports